import type { MigrationStrategies } from "./_types/migration-strategies";

export const PRICE_LIST_REVENUE_DEPARTMENT_MIGRATION_STRATEGIES: MigrationStrategies =
  {
    1: (oldDoc) => oldDoc,
  };
